module.exports = __webpack_public_path__ + "media/images/application/icons/icon-megaphon-orange-e62711aa5794a52058895aae54240b6b.svg";